/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitFileset} from '../api'

export const useMutationSubmitFileset = createReactQueryMutationHook('submitFileset', submitFileset)
